import React, { useState } from "react";
import { FiEdit2, FiPlus } from "react-icons/fi";
import CustomTable from "src/component/CustomTable";
import Modal from "src/component/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { CustomInput } from "src/component";
import { renderAlert } from "src/utils/functions";
import { addLocation, getAllLocations, updateLocation } from "src/services/api";
import { useMutation, useQuery } from "@tanstack/react-query";

const Locations = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [locationsData, setLocationsData] = useState(false);
  const { data, refetch } = useQuery({
    queryKey: ["GetLocations"],
    queryFn: getAllLocations,
    suspense: true,
  });
  const locations = data?.data;

  const columns = [
    {
      name: "S/N",
      cell: (_, i) => i + 1,
      width: "60px",
    },
    {
      name: "Name",
      grow: 2,
      cell: (row) => <div className="capitalize">{row?.name}</div>,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center justify-start gap-[2rem]">
          <div
            className="flex items-center justify-start my-1 gap-[.5rem] rounded-[1.2rem] text-[1.4rem]  font-normal cursor-pointer hover:text-defaultPrimary"
            onClick={() => {
              setModalOpen(true);
              setLocationsData(row);
            }}
          >
            <FiEdit2 size="1.6rem" />
            Update
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-end items-end gap-[3rem] mb-3">
        <button
          className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2"
          onClick={() => {
            setModalOpen(true);
            setLocationsData("");
          }}
        >
          <FiPlus size={15} />
          Add Store
        </button>
      </div>

      <CustomTable columns={columns} data={locations} />
      <Modal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        title={locationsData ? "Edit Warehouse" : "Add Warehouse"}
      >
        <AddStore
          editData={locationsData}
          refetch={refetch}
          setModalOpen={setModalOpen}
        />
      </Modal>
    </div>
  );
};

const AddStore = ({ editData, refetch, setModalOpen }) => {
  const { mutate, isLoading } = useMutation(
    editData ? updateLocation : addLocation,
    {
      onSuccess: (res) => {
        renderAlert({
          title: "Success",
          msg: res?.msg,
          type: "success",
        }).then((result) => {
          if (result) {
            setModalOpen(false);
          } else {
            setModalOpen(false);
          }
        });
        refetch();
      },
    }
  );
  const initialValues = {
    name: editData?.name ?? "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("appliance name is required"),
  });
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        mutate({ id: editData?.id, ...values });
      }}
    >
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="px-[3rem] py-[2rem]">
            <CustomInput
              title="Name"
              name="name"
              placeholder="Enter Name"
              onChange={handleChange}
              value={values.name}
              onBlur={handleBlur}
              formType="fill"
              isRequired={true}
            />
          </div>

          <div className="border-t border-t-gray">
            <div className="flex justify-end px-[3rem] py-[2rem]">
              <button
                disabled={isLoading}
                type="submit"
                className="btn-loader flex justify-center bg-lightPrimary items-center rounded-[5px]  text-defaultPrimary py-[2rem] px-[4rem] h-[3.5rem]"
              >
                {editData ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default Locations;
